import { createSlice } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';

const getInitialDateRange = () => {
    const start = DateTime.now().startOf('day').toUTC().toISO();
    const end = DateTime.now().endOf('day').toUTC().toISO();
    return { start, end };
};

const initialState = {
    equipmentTypeIds: [],
    dateRange: getInitialDateRange(),
};

const analyticsSelectionsSlice = createSlice({
    name: 'analyticsSelections',
    initialState,
    reducers: {
        setStoreEquipmentTypeIds(state, action) {
            state.equipmentTypeIds = action.payload;
        },
        setStoreDateRange(state, action) {
            state.dateRange = action.payload;
        },
    },
});

export const { setStoreEquipmentTypeIds, setStoreDateRange } = analyticsSelectionsSlice.actions;
export default analyticsSelectionsSlice.reducer;
